var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5127_1842)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7895 0.708252H-0.794434V20.2593H20.7895V0.708252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7892 8.53149H11.2856V0.710693H8.69158V8.53149H-0.787109V12.441H8.69158V20.2599H11.2856V12.441H20.7892V8.53149Z",
    fill: "#CE1124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.794434 2.98706V7.24345H3.91399L-0.794434 2.98706Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.80223 0.70752L1.73389 0.713115L7.83748 6.26209V0.70752H1.80223Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45047 7.21506L-0.794434 0.709229V2.24243L4.7244 7.21506H6.45047Z",
    fill: "#CE1124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5498 13.7537L20.7947 20.2595V18.7263L15.2759 13.7537H13.5498Z",
    fill: "#CE1124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.794434 18.0149V13.7585H3.91399L-0.794434 18.0149Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.80223 20.2929L1.73389 20.2873L7.83748 14.7383V20.2929H1.80223Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41304 13.752L-0.789551 20.2559L0.894199 20.2596L7.84509 14.0168V13.752H6.41304Z",
    fill: "#CE1124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7947 2.98608V7.24248H16.0874L20.7947 2.98608Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1974 0.70752L18.2668 0.713115L12.1621 6.26209V0.70752H18.1974Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7889 0.716553H19.1681L12.1694 7.00229V7.22238H13.6503L20.7889 0.716553Z",
    fill: "#CE1124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7947 18.0149V13.7585H16.0874L20.7947 18.0149Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1974 20.2929L18.2668 20.2873L12.1621 14.7383V20.2929H18.1974Z",
    fill: "#00247D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5127_1842"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.c563984978ff607a6abc6ba819a624e2.svg";
export { ForwardRef as ReactComponent };